import { getLabels } from "store/actions/forms-action";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AppDispatch } from "store/store";
import { setSelectedSection } from "store/slices/forms-slice";


export default () => {
    const dispatch: AppDispatch = useDispatch()
    const navigate = useNavigate();

    const { labels, forms_loading } = useSelector((state: any) => state.forms)

    useEffect(() => {
        dispatch(getLabels())
    }, [])

    const onPressTab = (item: any) => {
        dispatch(setSelectedSection(item))
        navigate('update-form-labels')
    }


    return {
        labels,
        forms_loading,
        onPressTab
    };
};
